var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tabs === 0)?_c('TabManutencaoListagem',{ref:"tabManutencaoListagem"}):_vm._e(),(_vm.tabs === 1)?_c('TabManutencaoTabela',{ref:"tabManutencaoTabela"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }